<script setup lang="ts">
import {computed, PropType} from "vue";
import {odsPill, PillSize, PillTheme} from "../odsPill";
import {IconName} from "../odsIcon";

const props = defineProps({
  message: {
    type: String,
    default: '',
  },
  messageTheme: {
    type: String as PropType<typeof PillTheme[keyof typeof PillTheme]>,
    default: PillTheme.Default,
  },
});

const messageIcon = computed(() => {
  switch (props.messageTheme) {
    case PillTheme.Warning:
      return IconName.Error;
    case PillTheme.Failure:
      return IconName.Cancel;
    case PillTheme.Success:
      return IconName.CheckCircle;
    default:
      return undefined;
  }
});
</script>

<template>
  <odsPill
      v-if="message"
      :label="message"
      :theme="messageTheme"
      :size="PillSize.Medium"
      :icon="messageIcon"
  />
</template>

<style scoped lang="scss">

</style>